import { IPV4_RE, IPV6_RE } from '../regexes';

export function validateCidr(value) {
    if (typeof value !== 'string') {
        return false;
    }
    const group = value.split('/');
    if (group.length !== 2) {
        return false;
    }
    const [address, mask] = group;
    if (IPV4_RE.test(address)) {
        const intmask = parseInt(mask, 10);
        return isFinite(mask) && intmask > 0 && intmask <= 32;
    } else if (IPV6_RE.test(address)) {
        const intmask = parseInt(mask, 10);
        return isFinite(intmask) && intmask > 0 && intmask <= 128;
    }
    return false;
}
